import axios from "axios";
import {AppDispatch, RootState} from "../../app/store";
import {authHeader} from "../../utils/AuthHeader";
import {AUTH_LOGOUT, CHANGE_COMPANY, LOGIN} from "./AuthReducer";
import localforage from "localforage";
import {LOGOUT, LOGOUT_WITHOUT_CLEAR} from "../MainReducer";
import {GetAllCompanyData, GetAllDefaultData} from "../CompanyDataTables/TablesActions";
import {showErrorToast, showToast} from "../../utils/showToast";
import { DATA_LOGOUT } from "../CompanyDataTables/CompanyDataReducer";
import {ActionCreators as UndoActionCreators} from "redux-undo";
import i18n from "i18next";

export const LoginAction = (email: string, password: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      const url = `/api/User/login`;
      const result = await axios.post(url, {
        Email: email,
        Password: password,
      });
      dispatch(Authenticate(result));
      return result.data.success;
    } catch (err) {}
  };
};

export const Signup = (email: string, password: string, companyName: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      const model = {
        Email: email,
        Password: password,
        companyName: companyName,
      };
      const response = await axios.post("/api/User/register", model);
      if(response.data.success) {
        showToast("success", "check circle", i18n.t('registration'), i18n.t(response.data.msg));
      } else if (response.data.msg && response.data.msg !== ""){
        showErrorToast(i18n.t('registration'), i18n.t(response.data.msg));
      } else {
        showErrorToast(i18n.t('registration'), i18n.t("register_user_err"));
      }
      return response.data.success;
    } catch (error: any) {
      showErrorToast(i18n.t('registration'), i18n.t("register_user_err"));
      return false;
    }
  };
};

export const Authenticate = (result: any) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    if (result.data.success) {
      const user = result.data; 
      if (user.token !== null && user.token !== "") {
        localStorage.user = JSON.stringify(user);
        localStorage.setItem("token", user.token);
        axios.defaults.headers.common = authHeader();

        dispatch({type: LOGIN, email: user.email, isAuthenticated: true, rights: user.rights});
        const companyId = getState().auth.companyId;
        if(companyId === -1) {
          dispatch({type: CHANGE_COMPANY, companyId: user.companyId, companyName: user.companyName, role: user.role});
        }
        dispatch(GetAllCompanyData());
      } 
    } else {
      let data = result.data;
      if (!data.msg || data.msg === "") {
        showErrorToast(i18n.t("login"), i18n.t("login_err"));
      } else {
        showErrorToast(i18n.t("login"), i18n.t(data.msg));
      }
      dispatch(Logout(true));
    }
  };
};

export const LoginToken = () => {
  return async (dispatch: AppDispatch) => {
    let token = localStorage.getItem("token");
    if (token) {
      const token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      const result = dispatch(LoginActionToken());
      return result;
    } else {
      dispatch(GetAllDefaultData());
      //dispatch({type: SET_MOUNTED, mounted: true});
      return false;
    }
  };
};

export const LoginActionToken = () => {
  return async (dispatch: AppDispatch) => {
    //dispatch({type: SET_LOADING, loading: true});
    try {
      const token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      const result = await axios.get("/api/User/loginToken");
      result.data.msg = "";
      dispatch(Authenticate(result));
      return result.data.success;
    } catch (err) {
      //dispatch(Logout(true));
      //showErrorToast(i18n.t("login"), i18n.t("unauthorized_msg"));
      return false;
    }
  };
};

export const Logout = (onlyDataLogout: boolean = false) => {
  return async (dispatch: AppDispatch) => {
    const lang = localStorage.getItem("lang") || i18n.language || "lt";
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("specimen");
    localStorage.clear();
    localStorage.setItem("lang", lang);
    if(!onlyDataLogout){
      dispatch({type: LOGOUT});
      localforage.clear();
    } else {
      dispatch({type: LOGOUT_WITHOUT_CLEAR});
      localforage.removeItem("persist:main");
      localforage.removeItem("persist:auth");
      localforage.removeItem("persist:companyData");
    }
    dispatch(UndoActionCreators.clearHistory());
    dispatch({type: AUTH_LOGOUT});
    dispatch({type: DATA_LOGOUT});
    dispatch(GetAllDefaultData());
  };
};

export const RequestPassChange = (email: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      const lang = localStorage.getItem("lang") || i18n.language || "lt";
      const response = await axios.post("/api/Password/requestPasswordChange/" + lang, {email});
      if (response.data.success) {
        showToast("warning", "envelope", i18n.t("change_pass"), i18n.t("change_pass_link") + email);
      } else if (response.data.msg && response.data.msg !== "") {
        setTimeout(() => {
          showErrorToast(i18n.t("change_pass"), i18n.t(response.data.msg) + (response.data.minutes ? " " + response.data.minutes : "" ));
        }, 1000);
      } else {
        setTimeout(() => {
          showErrorToast(i18n.t("change_pass"), i18n.t("change_pass_link_err"));
        }, 1000);
      }
      return response;
    } catch (error: any) {
      return error;
    }
  };
};
export const ChangePassword = (token: string, newPass: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      const lang = localStorage.getItem("lang") || i18n.language || "lt";
      const response = await axios.post("/api/Password/confirmPasswordToken/" + lang, {token, newPass});
      if(response.data.success) {
        showToast("success", "check circle", i18n.t("change_pass"), i18n.t("change_pass_success"));
      } else if (response.data.msg && response.data.msg !== "") {
        showErrorToast(i18n.t("change_pass"), i18n.t(response.data.msg));
      } else {
        showErrorToast(i18n.t("change_pass"), i18n.t("change_pass_err"));
      }
      return response;
    } catch (error: any) {
      return error;
    }
  };
};

export const ChangeSelectedCompany = (companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    if( companyId === null || companyId === undefined) return;
    const rights = getState().auth.rights;
    const company = rights.find(x => x.companyId === companyId);
    if(!company) return;
    try {
      const response = await axios.post("/api/User/changeCompany", {companyId});
      if(response.data.success) {
        const user = response.data.user; 
        if (user.token !== null && user.token !== "") {
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("token", user.token);
          axios.defaults.headers.common = authHeader();
          dispatch({type: CHANGE_COMPANY, companyId: companyId, companyName: company.companyName, role: user.role /*company.roleId*/});
        }
      } else {
        showErrorToast(i18n.t("error"), i18n.t("change_company_err"));
      }
    } catch (error: any) {
      showErrorToast(i18n.t("error"), i18n.t("change_company_err"));
    }
    //dispatch(GetAllCompanyData(companyId));
  };
}